import { FC } from "react";
import BNRichText, { BNRichTextProps } from "../BNRichText/BNRichText";

interface RichTextComponent extends FC<BNRichTextProps> {
  noJsRequired: true;
}

const RichText: RichTextComponent = (props) => {
  return <BNRichText {...props}></BNRichText>;
};

RichText.noJsRequired = true;

export default RichText;
